import { error, success, warning } from '@react/react-spectrum/Toast'
import { __ } from 'i18n-for-browser'
import '../config/i18n'
import analytics from '../config/analytics'

import axios from 'axios'
import filesize from 'filesize' 
import { v4 as uuidv4 } from 'uuid';

import { 
    TIMEOUT_TOAST_SUCCESS,
    TIMEOUT_TOAST_FAIL,
    TIMEOUT_TOAST_WARNING,
    UPLOAD_FILE_SIZE_LIMIT_IMAGE,
    UPLOAD_FILE_SIZE_LIMIT_ATN,
    STATUS_CODE_FAIL_BAD_REQUEST
} from './constants'
import { replacerFunc } from "./utils"
import {
    pData
} from './consoleApi'

export const getRef = (url) => {
    const curUrl = new URL(url)
    let curRef = curUrl.searchParams.get('ref')
    if (curRef) {
        curRef = curRef.replace(/\/$/, '')
    }
    switch (curRef) {
    case 'home':
    case 'autotone':
    case 'preset':
    case 'smartobject':
    case 'textlayer':
    case 'imagecutout':
    // case 'bannerreflow':
    case 'psactions':
    case 'signup':
    case 'awsmp':
    case 'create':
    case 'form':
    case 'credinfo':
    case 'accesstoken':
    case 'helloworld':
    case 'buildsomethingcool':
    case 'contactsales':
    case 'enterprisesetupmeeting':
        analytics.sendPageName(curRef)
        return curRef
    default:
        analytics.sendPageName('home')
        return 'home'
    }
}

export async function copyText (text, page) {
    analytics.sendEventName('click', `${page}:copyapikey`)
    const el = document.createElement('textarea')
    el.value = text
    el.setAttribute('readonly', '')
    el.style.position = 'absolute'
    el.style.left = '-9999px'
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
}

export async function downloadFile (page, file) {
    analytics.sendEventName('click', `${page}:download:${file}`)
    import(`../download/${file}`).then((module) => {
        const url = module.default;
        fetch(url, {
            mode: 'no-cors' /*{mode:'cors'}*/
        }).then((transfer) => {
            return transfer.blob();
        }).then((bytes) => {
            let elm = document.createElement('a');
            elm.href = URL.createObjectURL(bytes);
            elm.setAttribute('download', file);
            elm.click()
        }).catch((error) => {
            logMsg(error,null,'downloadFile');
        })
    });
}

export function isStringValid(str, errStr) {
    return true //TODO
    if (errStr) {
        return str !== errStr
    }
    return (str !== null && str !== "")
}

export function isFormEmailValid(str) {
    return str.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
}

export function logMsg(e, msg, title) {
    if (process.env.REACT_APP_CONFIG_APP_ENV === 'stage') {
        console.log('*************************************')
        if (msg) {
            switch (typeof msg) {
                case 'object':
                    console.log(`${title || ''}: ${JSON.stringify(msg,null,2)}`)
                    break;
                case 'array':
                    console.table(msg)
                    break;
                default:
                    console.log(`${title || ''}: ${msg}`)
                    break;
            }
        }
        if (e) {
            console.log(`LOG: ${e.message} - ${e.stack}`)
        }
    }
}

export function logAlert (e, msg) {
    const str = e && e.message || msg || 'Something went wrong'
    analytics.sendEventName('toast', `error:${str}`)
    error(`${__('msg_error_space')}${str}`, {
        timeout: TIMEOUT_TOAST_FAIL
    })
}

export function logAlertMissingRole (e, page) {
    const str = e && e.message || 'Something went wrong'
    analytics.sendEventName('toast', `error:${str}`)
    error(str, {
        timeout: TIMEOUT_TOAST_FAIL,
        actionLabel: __('btn_go_to_sing_in_personal'),
        onAction: (e) => signOutClick(page)
    })
}

export function logWarning (msg) {
    analytics.sendEventName('toast', `warning:${msg}`)
    warning(msg, {
        timeout: TIMEOUT_TOAST_WARNING
    })
}

export function logSuccess (msg) {
    analytics.sendEventName('toast', `success:${msg}`)
    success(msg, {
        timeout: TIMEOUT_TOAST_SUCCESS
    })
}

export function setBodyHeight(className) {
    let newHeight = 660
    if (window.easybake) {
        const elm = document.getElementsByClassName(className)[0]
        if (elm && elm.offsetHeight > 660) {
            newHeight = elm.offsetHeight
        }
        window.easybake.parent.setHeight(`${newHeight}px`);
        window.easybake.parent.scrollTop()
    }
    window.scrollTo(0, 0);
}

export function getUrlParameter(name, url) {
    if (!url) {
        url = document.location.href
    }
    const curUrl = new URL(url)
    const val = curUrl.searchParams.get(name)
    return val
}

export const getDebugMode = (url) => {
    if (!url) {
        url = document.location.href
    }
    const curUrl = new URL(url)
    const curMode = curUrl.searchParams.get('d')
    switch (curMode) {
    case "1":
        return true
    default:
        return false
    }
}

export function getFilenameWithoutExt (longName) {
    var fileName = longName.substring(longName.lastIndexOf('/') + 1)
    return fileName.split('.').slice(0, -1).join('.')
}

export function ccApiCall (method, url, options, cb) {
    try {
        const request = require('request')
        request(options, (error, response, body) => {
            let json
            if (error) {
                logMsg(error,null,'ccApiCall')
            }
            if (body) {
                json = JSON.parse(body)
                if (response && response.statusCode >= 400) {
                    cb(null, json)
                } else {
                    cb(json, response)
                }
            } else {
                cb(null, `${response}, JSON.stringify(options): ${JSON.stringify(options)}`)
            }
        })
    } catch (e) {
        logAlert(e)
        cb(null, e)
    }
};

export function getEncodedURI(path) {
    if (path) {
        let paths = []
        let domain = ''
        if (path.match(/http/)) {
            const urls = path.split('//')
            domain = `${urls[0]}//`
            paths = urls[1].split(/\//)
            domain += `${paths.shift()}/`
        } else {
            paths = path.split('/')
        }
        for (var i = 0; i < paths.length; i++) {
            paths[i] = encodeURIComponent(paths[i])
        }
        return `${domain}${paths.join('/')}`
    } else {
        return ''
    }
}

export function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export function getSpinnerCustomStyle (defaultDocWidth, defaultDocHeight, customFiles) {
    const width = customFiles && customFiles.length > 0 && customFiles.filter( file => file.assetType === 'image')[0].width
    const height = customFiles && customFiles.length > 0 && customFiles.filter( file => file.assetType === 'image')[0].height
    if (!width || !height) {
        return { width: '100%', height: '100%'}
    }
    if (width && width > height && width > defaultDocWidth) {
        const newHeight = height * (defaultDocWidth/width)
        return { width: `${defaultDocWidth}px`, height: `${Math.ceil(newHeight)}px`}
    }
    if (height && height > width && height > defaultDocHeight) {
        const newWidth = width * (defaultDocHeight/height)
        return { width: `${Math.ceil(newWidth)}px`, height: `${defaultDocHeight}px`}
    }
    if (width === height && width > defaultDocHeight) {
        return { width: `${defaultDocHeight}px`, height: `${defaultDocHeight}px`}
    }
    return {width: `${width}px`, height: `${height}px`}
}

export async function uploadAssetFile(page, file, opts={}, cb) {
    try {
        axios.put(file, opts.data, opts.config)
            .then((response) => {
                logMsg(null, response.status, 'Asset upload')
                analytics.sendEventName('upload', `${page}:${response.status}`)
                cb(response)
            })
            .catch((error) => {
                analytics.sendEventName('upload', `${page}:${error && error.response && error.response.status}`)
                logMsg(null, error, 'Asset upload error')
                cb(false, 'The image or action URL may be expired')
            })
            .then(() => {
                // console.log('uploadAsset done');
            })
    } catch(e) {
        cb(null, e)
    }
}

export function createRecaptchaElement() {
    const script = document.createElement('script')
    script.setAttribute('src', process.env.REACT_APP_CONFIG_APP_RECAPTCHA_SCRIPT_URL)
    const challenge = document.createElement('div')
    challenge.className = 'g-recaptcha'
    challenge.dataset.size = 'invisible'
    challenge.dataset.sitekey = process.env.REACT_APP_CONFIG_APP_RECAPTCHA_SITE_KEY
    document.body.appendChild(script)
    document.body.appendChild(challenge)
}

export function getFileSize (num) {
    if (num) {
        return filesize(num, { round: 0 })
    } else {
        return ''
    }
}

export function getFileSizeRange (num) {
    switch (true) {
        case num <= 1024 * 1024:
            return '0-1mb'
        case num <= 1024 * 1024 * 2:
            return '1-2mb'
        case num <= 1024 * 1024 * 3:
            return '2-3mb'
        case num <= 1024 * 1024 * 4:
            return '3-4mb'
        case num <= 1024 * 1024 * 5:
            return '4-5mb'
        case num <= 1024 * 1024 * 6:
            return '5-6mb'
        case num <= 1024 * 1024 * 7:
            return '6-7mb'
        case num <= 1024 * 1024 * 8:
            return '7-8mb'
        case num <= 1024 * 1024 * 9:
            return '8-9mb'
        case num <= 1024 * 1024 * 10:
            return '9-10mb'
        default:
            return '10-mb'
    }
}

export function getExpectedFileSizeToUpload(assetType) {
    switch (assetType) {
        case 'image':
            return UPLOAD_FILE_SIZE_LIMIT_IMAGE
        case 'action':
            return UPLOAD_FILE_SIZE_LIMIT_ATN
        default:
            return UPLOAD_FILE_SIZE_LIMIT_IMAGE
    }
}

export function isValidFileSize(actualFileSize, expectedFileSize) {
    return actualFileSize <= expectedFileSize
}

export function isValidFileType(file, assetType, fileTypes) {
    try {
        const arr = (new Uint8Array(file)).subarray(0, 4);
        let header = "";
        for(var i = 0; i < arr.length; i++) {
            header += arr[i].toString(16);
        }
        // logMsg(header);
        let type
        if (assetType === 'image') {
            switch (header) {
                case "89504e47":
                    return fileTypes.find(type => type==="image/png").length > 0
                case "ffd8ffe0":
                case "ffd8ffe1":
                case "ffd8ffe2":
                case "ffd8ffe3":
                case "ffd8ffe8":
                    return fileTypes.find(type => type==="image/jpeg").length > 0
                default:
                    return (`${__('msg_error_file_type_image')}`)
            }
        }
        if (assetType === 'action') {
            switch (header) {
                case "00010":
                    return fileTypes.find(type => type==="application/octet-stream").length > 0
                default:
                    return (`${__('msg_error_file_type_actions')}`)
            }
        }
    } catch(e) {
        logAlert(e)
    }
}

export async function runRecaptcha(ut) {
    try {
        const token = await window.grecaptcha.execute()
        const response = await fetch(
            `${process.env.REACT_APP_CONFIG_APP_IMAGE_API_ENDPOINT}/utils/recaptcha`,
            {
                headers: {
                    'x-api-key': process.env.REACT_APP_CONFIG_APP_KEY,
                    'Authorization': `Bearer ${ut}`,
                    'x-recaptcha-token': token,
                },
            }
        )
        logMsg(null, response, 'runRecaptcha')
        return {
            response: response,
            error: false
        }
    } catch(e) {
        return {
            response: null,
            error: true,
            e: e
        }
    }
}

export async function getAperitifToken() {
    try {
        const token = await window.grecaptcha.execute()
        const response = await fetch(
            `${process.env.REACT_APP_CONFIG_APP_IMAGE_API_ENDPOINT}/utils/aperitif/token`,
            {
                headers: {
                    'x-api-key': process.env.REACT_APP_CONFIG_APP_KEY,
                    'x-recaptcha-token': token
                },
            }
        )
        logMsg(null, response, 'getAperitifToken')
        if (response.status >= STATUS_CODE_FAIL_BAD_REQUEST) {
            return {
                response: response,
                error: true
            }
        } else {
            return {
                response: response,
                error: false
            }
        }
    } catch(e) {
        return {
            response: null,
            error: true,
            e: e
        }
    }
}

export async function getAperitifStorage(num, getAperitifStorage) {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_CONFIG_APP_IMAGE_API_ENDPOINT}/utils/aperitif/storage?num=${num}`,
            {
                headers: {
                    'x-api-key': process.env.REACT_APP_CONFIG_APP_KEY,
                    'Authorization': `Bearer ${getAperitifStorage.userToken}`
                },
            }
        )
        logMsg(null, response, 'getAperitifStorage')
        if (response.status >= STATUS_CODE_FAIL_BAD_REQUEST) {
            return {
                response: response,
                error: true
            }
        } else {
            return {
                response: response,
                error: false
            }
        }
    } catch(e) {
        return {
            response: null,
            error: true,
            e: e
        }
    }
}

export async function runAperitifOperation(ut, token, bodyObject) {
    try {
        const cisEndpoint = ut ? `${process.env.REACT_APP_CONFIG_APP_IMAGE_API_ENDPOINT}/pie/psdService/photoshopActions` : `${process.env.REACT_APP_CONFIG_APP_IMAGE_API_ENDPOINT}/utils/aperitif/operation/pie/psdService/photoshopActions`
        const requestOptions = {
            method: 'POST',
            headers: {
                'X-API-KEY': process.env.REACT_APP_CONFIG_APP_KEY,
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(bodyObject)
        }
        const response = await fetch(cisEndpoint, requestOptions)
        logMsg(null, response, 'runAperitifOperation')

        const parsed = await response.json();
        logMsg(null, parsed, 'runAperitifOperation')
        if (parsed._links && parsed._links.self && parsed._links.self.href) {
            return getResults(parsed._links.self.href, token);
        }
        return {
            response: response,
            error: true
        }
    } catch(e) {
        return {
            response: null,
            error: true,
            e: e
        }
    }
}

export async function getResults(pollHref, token) {
    const response = await fetch(pollHref, {
        method: 'GET',
        headers: {
            'x-api-key': process.env.REACT_APP_CONFIG_APP_KEY,
            Authorization: `Bearer ${token}`
        }
    });
    const POLL_MS = 1000;
    if (response.status === 200) {
        const job = await response.json();
        const status = job.outputs && job.outputs[0].status || job.status;
        logMsg(null, status, 'getResults status')
        switch (status) {
            case 'succeeded':
                return {
                    response: response,
                    job: job,
                    error: false
                }
            case 'running':
            case 'pending':
                await wait(POLL_MS);
                return getResults(pollHref, token);
            case 'failed':
                // throw new Error(`Job failed, job id was ${job.jobID}`);
                return {
                    response: response,
                    error: true,
                    job: job,
                    e: new Error(`Job failed, job id was ${job.jobID}`)
                }
            default:
                // throw new Error(
                //     `Unexpected job status of ${status}, job id was ${job.jobID}`
                // );
                return {
                    response: response,
                    error: true,
                    job: job,
                    e: new Error(
                        `Unexpected job status of ${status}, job id was ${job.jobID}`
                    )
                }
        }
    } else {
        throw new Error(`Expected 200 when polling ${pollHref}`);
    }
}

function wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function getUtStorage(num, ut) {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_CONFIG_APP_IMAGE_API_ENDPOINT}/utils/storage?num=${num}`,
            {
                headers: {
                    'x-api-key': process.env.REACT_APP_CONFIG_APP_KEY,
                    'Authorization': `Bearer ${ut}`
                },
            }
        )
        logMsg(null, response, 'getUtStorage')
        return {
            response: response,
            error: false
        }
    } catch(e) {
        return {
            response: null,
            error: true,
            e: e
        }
    }
}

export async function getPutUrl(tempOutputs, assetNum) {
    try {
        const uuid = uuidv4()
        return {
            url: tempOutputs.urls[assetNum],
            error: false,
            msg: null
        }
    } catch(e) {
        return {
            url: null,
            error: true,
            msg: e.message
        }
    }
}

export function clickElement(element) {
    document.getElementById(element).click()
}

export function isLocalhost() {
    if (window.location.hostname.includes('localhost') ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )) {
        return true
    }
}

export function getStartedUrl() {
    let parentHost = window.location.ancestorOrigins && window.location.ancestorOrigins.length > 0 ? window.location.ancestorOrigins[0] : window.location.origin
    if (!isLocalhost() || !getDebugMode()) {
        parentHost += '/photoshop/api'
    }
    return `${parentHost}/signup/?ref=signup`
}

export async function getAwsMarketplaceUser(ut, customerId) {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_CONFIG_APP_IMAGE_API_ENDPOINT}/utils/marketplaceUser/${customerId}`,
            {
                headers: {
                    'x-api-key': process.env.REACT_APP_CONFIG_APP_KEY,
                    'Authorization': `Bearer ${ut}`,
                    'Content-Type': 'application/json'
                },
            }
        )
        // logMsg(null, response)
        if (response.status >= STATUS_CODE_FAIL_BAD_REQUEST) {
            return {
                response: response,
                error: true
            }
        } else {
            return {
                response: response,
                error: false
            }
        }
    } catch(e) {
        return {
            response: null,
            error: true,
            e: e
        }
    }
}

export async function setAwsMarketplaceUser(ut, bodyObject) {
    try {
        const response = await fetch(
            `${process.env.REACT_APP_CONFIG_APP_IMAGE_API_ENDPOINT}/utils/marketplaceUser`,
            {
                method: 'POST',
                headers: {
                    'x-api-key': process.env.REACT_APP_CONFIG_APP_KEY,
                    'Authorization': `Bearer ${ut}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(bodyObject)
            }
        )
        // logMsg(null, response)
        if (response.status >= STATUS_CODE_FAIL_BAD_REQUEST) {
            return {
                response: response,
                error: true
            }
        } else {
            return {
                response: response,
                error: false
            }
        }
    } catch(e) {
        return {
            response: null,
            error: true,
            e: e
        }
    }
}

export function goToUrlTarget (url, target) {
    window.open(url, target)
}

export async function pUserInfo(uInfo, endpoint) {
    const res = await pData(uInfo, endpoint)
    if (res && res.status) {
        analytics.sendEventName('api', `postdata:${res.status}`)
        return true
    } else {
        analytics.sendEventName('api', 'postdata:fail')
        return false
    }
}

export function getPlatform () {
    const isMac = navigator.platform.toUpperCase().indexOf('MAC')>=0;
    if (isMac) {
        return 'mac'
    }
    return 'win'
}

export function signOutClick(page) {
    if (window.easybake) {
        analytics.sendEventName('click', `${page}:signout`)
        window.easybake.parent.signOut()
    }
}